// extracted by mini-css-extract-plugin
export default {"Button":"IPButton_Button__pWuxL","Rounded":"IPButton_Rounded__U5cZu"};